module.exports = __webpack_public_path__ + "static/img/icon-shield.815bb803.png";